<template>
  <v-container>
    <v-row>
      <v-col cols="12" justify-center align-start>
        <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3" v-for="n in 6" :key="n">
        <v-skeleton-loader ref="skeleton" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DownloadsSkeleton"
};
</script>